module.exports = __webpack_public_path__ + "std/img/zh_HK.bf423ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/langs/zh_HK.png
// module id = FJK5
// module chunks = 0 1